module.exports = __webpack_public_path__ + "media/images/post_mypage-d692ff190c9201f9e9fb4d57a3e7ba7b.svg";